// ============================================================================
// MY PERMISSIONS SERVICE
// ============================================================================
// Fetches the current user's effective permissions from the API. Consumed by
// AuthContext to replace the empty modules array that tenant-hub returns on
// /Auth/authenticate with FB's own Module → Menu → UI → Element tree.
//
// The response shape matches UserPermissionContext (roles / scopeConfiguration
// / modules / summary) — same DTO the tenant-hub-mode login flow already
// consumes — so it drops straight into permissionContext with no reshaping.

import { get } from '../client/axiosClient';
import { myPermissionsEndpoints } from '../endpoints/iam.endpoints';
import type { ApiResponse } from '../types';
import type { UserPermissionContext } from '../types/auth.types';

class MyPermissionsService {
  /** Fetch current user's effective module/menu/UI/element permission tree */
  async getMyPermissions(): Promise<ApiResponse<UserPermissionContext>> {
    const response = await get<ApiResponse<UserPermissionContext>>(myPermissionsEndpoints.get());
    return response.data;
  }
}

export const myPermissionsService = new MyPermissionsService();
export default myPermissionsService;
